import React from "react";
import processBoxStyle from "./processBoxStyle";
import { Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import _map from "lodash/map";
import { getProcessConfig } from "../../../services/serviceWorldService";
import IconCheckCircleBig from "../../../assets/icons/serviceOverview/IconCheckCircleBig";
import IconProgress from "../../../assets/icons/serviceOverview/IconProgress";
import { ProcessBoxLoader } from "../../ContentLoader/ProcessBoxLoader";
import ContentBox from "../../Box/ContentBox/ContentBox";
import IconWrapper from "../../IconWrapper/IconWrapper";
import { AbstractCase } from "../../../types/Entities/AbstractCase";

type ProcessBoxProp = {
  product: AbstractCase;
};

const ProcessBox = ({ product }: ProcessBoxProp) => {
  if (!product) {
    return (
      <ContentBox icon={IconProgress} headline={"Prozessablauf"} alignContent={"stretch"} loading={!product}>
        <ProcessBoxLoader />
      </ContentBox>
    );
  }

  if (product.isCustomerDataCompleted) {
    return null;
  }

  const processConfig = getProcessConfig(product);

  if (!processConfig) {
    return null;
  }

  return (
    <ContentBox icon={IconProgress} headline={processConfig.headline} alignContent={"stretch"} loading={!product}>
      <Grid container>
        {_map(processConfig.steps, (step, index: number) => (
          <React.Fragment key={index}>
            <Grid size={2}>
              <Stack
                sx={[{
                  alignItems: "center"
                }, processBoxStyle.iconContainer]}>
                {index === 0 ? <Grid sx={processBoxStyle.connectorLineInvisible} /> : <Grid sx={processBoxStyle.connectorLine} />}
                <Grid sx={processBoxStyle.progressIcons}>
                  {step.done ? (
                    <IconCheckCircleBig sx={processBoxStyle.progressIcons} />
                  ) : (
                    <IconWrapper icon={step.icon} alt="Step Icon" sx={processBoxStyle.progressIcons} />
                  )}
                </Grid>
                {index === processConfig.steps.length - 1 ? (
                  <Grid sx={processBoxStyle.connectorLineInvisible} />
                ) : (
                  <Grid sx={processBoxStyle.connectorLine} />
                )}
              </Stack>
            </Grid>
            <Grid
              sx={[processBoxStyle.textBlock, step.done ? processBoxStyle.done : null]}
              size={10}>
              <Typography sx={processBoxStyle.stepHeading}>{step.headline}</Typography>
              <Typography sx={processBoxStyle.stepText}>{step.content}</Typography>
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </ContentBox>
  );
};

export default ProcessBox;
